import { all, put, takeEvery } from "redux-saga/effects";
import { fetcher, getErrorMsg, handleError } from "lib/fetch";
import * as actions from "./actions";

const url = "sections";

function* loadSections(action) {
  try {
    const { params, token } = action.payload;
    // Add pagination parameters to the request
    const requestParams = {
      ...params,
      page: params.page || 1,
      limit: params.limit || 10,
    };
    const res = yield fetcher.post("sections", requestParams, token);
    yield put(actions.loadSections.success(res.data));
  } catch (error) {
    handleError(error);
    yield put(actions.loadSections.failure(getErrorMsg(error)));
  }
}

function* showSection(action) {
  try {
    const { id, token } = action.payload;
    const res = yield fetcher.get(`${url}/${id}`, token);
    yield put(actions.showSection.success(res.data));
  } catch (error) {
    handleError(error);
    yield put(actions.showSection.failure(getErrorMsg(error)));
  }
}

function* createSection(action) {
  try {
    const { params, token } = action.payload;
    const res = yield fetcher.post(`${url}/create`, params, token);
    yield put(actions.createSection.success(res.data));
  } catch (error) {
    handleError(error);
    yield put(actions.createSection.failure(getErrorMsg(error)));
  }
}

function* updateSection(action) {
  try {
    const { params, id, token } = action.payload;
    const res = yield fetcher.post(`${url}/update/${id}`, params, token);
    yield put(actions.updateSection.success(res.data));
  } catch (error) {
    handleError(error);
    yield put(actions.updateSection.failure(getErrorMsg(error)));
  }
}

function* deleteSection(action) {
  try {
    const { id, token } = action.payload;
    yield fetcher.get(`${url}/delete/${id}`, token);
    yield put(actions.deleteSection.success(id));
  } catch (error) {
    handleError(error);
    yield put(actions.deleteSection.failure(getErrorMsg(error)));
  }
}

export default function* watchSections() {
  yield all([
    takeEvery(actions.LOAD_SECTIONS.REQUEST, loadSections),
    takeEvery(actions.SHOW_SECTION.REQUEST, showSection),
    takeEvery(actions.CREATE_SECTION.REQUEST, createSection),
    takeEvery(actions.UPDATE_SECTION.REQUEST, updateSection),
    takeEvery(actions.DELETE_SECTION.REQUEST, deleteSection),
  ]);
}
